/* @flow */
import type { Node } from 'react';
import React, { useEffect, useState } from 'react';
import {
	PriceAvgRow,
	PriceDate,
	PriceDiffContent,
	PriceDifference,
	PriceDiffInfo,
	PriceDiffRow,
	PriceDiffScroll,
	PriceDiffTitle,
	PriceDiffTooltipWrapper,
	PriceHistoryImg,
	PriceHistoryWrapper,
	PriceMeterText,
	PricePerMeter,
	PriceValue,
	ShowMoreBtn,
} from './styles';
import { priceDiffIcon } from '../Icons';
import { Popover } from '../Tooltip/Tooltip';
import { formatValuesNumber } from '../../utils/formatting';
import type { TPriceHistory } from '../../types/apart';

type TProps = {
	priceHistory: TPriceHistory[],
	pricePerMeter: number,
	avrPriceMeter: number,
	maxShow?: number,
};

const PriceDiffHistory = ({ priceHistory, pricePerMeter, avrPriceMeter, maxShow }: TProps): Node => {
	const sortedHistory = priceHistory.sort((a, b) => new Date(b.date) - new Date(a.date));
	const [shownHistory, setShownHistory] = useState(null);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		setShownHistory(sortedHistory.slice(0, maxShow));
	}, [sortedHistory]);

	const OpenHistory = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		setShownHistory(isOpen ? sortedHistory : sortedHistory.slice(0, maxShow));
	}, [isOpen]);

	const PRICE_CONTENT = (
		<PriceDiffTooltipWrapper>
			<PriceDiffTitle>История цены</PriceDiffTitle>

			<PriceDiffContent>
				<PriceDiffScroll>
					{shownHistory?.map((value) => {
						const date = new Date(value.date);
						const isPriceRise = value.priceDiff > 0;

						return (
							<PriceDiffRow key={date}>
								<PriceDate>
									{date.toLocaleString('ru', {
										month: 'numeric',
										day: 'numeric',
										year: 'numeric',
									})}
								</PriceDate>
								<PriceValue>{formatValuesNumber(value.price, 'rub')}</PriceValue>
								{value.priceDiff !== 0 && (
									<PriceDifference $isRise={isPriceRise}>
										{isPriceRise ? '+' : '-'}&nbsp;
										{formatValuesNumber(Math.abs(value.priceDiff), 'rub')}
									</PriceDifference>
								)}
							</PriceDiffRow>
						);
					})}
				</PriceDiffScroll>
				{sortedHistory.length > maxShow && (
					<ShowMoreBtn onClick={OpenHistory}>{isOpen ? 'Скрыть' : 'Показать всю'} историю</ShowMoreBtn>
				)}
			</PriceDiffContent>
			<PriceDiffInfo>
				<PriceAvgRow>
					<PriceMeterText>Стоимость кв. м. в этой квартире</PriceMeterText>
					<PricePerMeter>{formatValuesNumber(pricePerMeter, 'rubSquare')}</PricePerMeter>
				</PriceAvgRow>

				<PriceAvgRow>
					<PriceMeterText>Средняя стоимость кв. м. в этом районе</PriceMeterText>
					<PricePerMeter>{formatValuesNumber(avrPriceMeter, 'rubSquare')}</PricePerMeter>
				</PriceAvgRow>
			</PriceDiffInfo>
		</PriceDiffTooltipWrapper>
	);

	return (
		<PriceHistoryWrapper>
			<Popover content={PRICE_CONTENT} theme="priceDiff" placement="bottom-end" arrow>
				<PriceHistoryImg viewBox="0 0 40 32">{priceDiffIcon}</PriceHistoryImg>
			</Popover>
		</PriceHistoryWrapper>
	);
};

PriceDiffHistory.defaultProps = {
	maxShow: 10,
};

export default PriceDiffHistory;
